/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceEventsService {
  /** @summary Create */
  createServiceEvent: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateServiceEventBody, CreateServiceEventParameters, TMeta, TSignal>,
      client?: (
        schema: CreateServiceEventSchema,
        options: ServiceOperationMutationFnOptions<CreateServiceEventBody, CreateServiceEventParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateServiceEventData, CreateServiceEventError>>
    ): Promise<RequestFnResponse<CreateServiceEventData, CreateServiceEventError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateServiceEventParameters> | void
    ): ServiceOperationMutationKey<CreateServiceEventSchema, CreateServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<CreateServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceEventSchema,
        CreateServiceEventData,
        CreateServiceEventParameters,
        TVariables,
        OperationError<CreateServiceEventError>,
        TContext
      >
    ): UseMutationResult<CreateServiceEventData, OperationError<CreateServiceEventError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.createServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceEventSchema,
        CreateServiceEventData,
        CreateServiceEventParameters,
        TVariables,
        OperationError<CreateServiceEventError>,
        TContext
      >
    ): UseMutationResult<CreateServiceEventData, OperationError<CreateServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createServiceEventTotal = qraft.serviceEventsService.createServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createServiceEventTotal = qraft.serviceEventsService.createServiceEvent.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventSchema,
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createServiceEventPendingMutationVariables = qraft.serviceEventsService.createServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createServiceEventMutationData = qraft.serviceEventsService.createServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateServiceEventData,
        OperationError<CreateServiceEventError>,
        MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventSchema,
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateServiceEventData,
          OperationError<CreateServiceEventError>,
          MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventSchema,
            CreateServiceEventBody,
            CreateServiceEventData,
            CreateServiceEventParameters,
            OperationError<CreateServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.createServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.createServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceEventSchema,
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            CreateServiceEventData,
            CreateServiceEventError,
            MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceEventSchema,
              CreateServiceEventBody,
              CreateServiceEventData,
              CreateServiceEventParameters,
              OperationError<CreateServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateServiceEventData,
          CreateServiceEventError,
          MutationVariables<CreateServiceEventBody, CreateServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: CreateServiceEventSchema;
    types: {
      parameters: CreateServiceEventParameters;
      data: CreateServiceEventData;
      error: CreateServiceEventError;
      body: CreateServiceEventBody;
    };
  };
  /** @summary Reschedule */
  rescheduleServiceEvent: {
    /** @summary Reschedule */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RescheduleServiceEventBody,
        RescheduleServiceEventParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RescheduleServiceEventSchema,
        options: ServiceOperationMutationFnOptions<
          RescheduleServiceEventBody,
          RescheduleServiceEventParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<RescheduleServiceEventData, RescheduleServiceEventError>>
    ): Promise<RequestFnResponse<RescheduleServiceEventData, RescheduleServiceEventError>>;
    /** @summary Reschedule */
    getMutationKey(
      parameters: DeepReadonly<RescheduleServiceEventParameters> | void
    ): ServiceOperationMutationKey<RescheduleServiceEventSchema, RescheduleServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RescheduleServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<RescheduleServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        RescheduleServiceEventSchema,
        RescheduleServiceEventData,
        RescheduleServiceEventParameters,
        TVariables,
        OperationError<RescheduleServiceEventError>,
        TContext
      >
    ): UseMutationResult<RescheduleServiceEventData, OperationError<RescheduleServiceEventError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.rescheduleServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RescheduleServiceEventSchema,
        RescheduleServiceEventData,
        RescheduleServiceEventParameters,
        TVariables,
        OperationError<RescheduleServiceEventError>,
        TContext
      >
    ): UseMutationResult<RescheduleServiceEventData, OperationError<RescheduleServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const rescheduleServiceEventTotal = qraft.serviceEventsService.rescheduleServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const rescheduleServiceEventTotal = qraft.serviceEventsService.rescheduleServiceEvent.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleServiceEventSchema,
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const rescheduleServiceEventPendingMutationVariables = qraft.serviceEventsService.rescheduleServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const rescheduleServiceEventMutationData = qraft.serviceEventsService.rescheduleServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RescheduleServiceEventData,
        OperationError<RescheduleServiceEventError>,
        MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleServiceEventSchema,
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RescheduleServiceEventData,
          OperationError<RescheduleServiceEventError>,
          MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Reschedule */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleServiceEventSchema,
            RescheduleServiceEventBody,
            RescheduleServiceEventData,
            RescheduleServiceEventParameters,
            OperationError<RescheduleServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Reschedule
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.rescheduleServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.rescheduleServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleServiceEventSchema,
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            RescheduleServiceEventData,
            RescheduleServiceEventError,
            MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleServiceEventSchema,
              RescheduleServiceEventBody,
              RescheduleServiceEventData,
              RescheduleServiceEventParameters,
              OperationError<RescheduleServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          RescheduleServiceEventData,
          RescheduleServiceEventError,
          MutationVariables<RescheduleServiceEventBody, RescheduleServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: RescheduleServiceEventSchema;
    types: {
      parameters: RescheduleServiceEventParameters;
      data: RescheduleServiceEventData;
      error: RescheduleServiceEventError;
      body: RescheduleServiceEventBody;
    };
  };
  /** @summary Cancel */
  cancelServiceEvent: {
    /** @summary Cancel */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CancelServiceEventBody, CancelServiceEventParameters, TMeta, TSignal>,
      client?: (
        schema: CancelServiceEventSchema,
        options: ServiceOperationMutationFnOptions<CancelServiceEventBody, CancelServiceEventParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CancelServiceEventData, CancelServiceEventError>>
    ): Promise<RequestFnResponse<CancelServiceEventData, CancelServiceEventError>>;
    /** @summary Cancel */
    getMutationKey(
      parameters: DeepReadonly<CancelServiceEventParameters> | void
    ): ServiceOperationMutationKey<CancelServiceEventSchema, CancelServiceEventParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CancelServiceEventBody, TContext = unknown>(
      parameters: DeepReadonly<CancelServiceEventParameters>,
      options?: ServiceOperationUseMutationOptions<
        CancelServiceEventSchema,
        CancelServiceEventData,
        CancelServiceEventParameters,
        TVariables,
        OperationError<CancelServiceEventError>,
        TContext
      >
    ): UseMutationResult<CancelServiceEventData, OperationError<CancelServiceEventError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventsService.cancelServiceEvent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CancelServiceEventSchema,
        CancelServiceEventData,
        CancelServiceEventParameters,
        TVariables,
        OperationError<CancelServiceEventError>,
        TContext
      >
    ): UseMutationResult<CancelServiceEventData, OperationError<CancelServiceEventError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const cancelServiceEventTotal = qraft.serviceEventsService.cancelServiceEvent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const cancelServiceEventTotal = qraft.serviceEventsService.cancelServiceEvent.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServiceEventSchema,
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const cancelServiceEventPendingMutationVariables = qraft.serviceEventsService.cancelServiceEvent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const cancelServiceEventMutationData = qraft.serviceEventsService.cancelServiceEvent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CancelServiceEventData,
        OperationError<CancelServiceEventError>,
        MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServiceEventSchema,
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CancelServiceEventData,
          OperationError<CancelServiceEventError>,
          MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Cancel */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServiceEventSchema,
            CancelServiceEventBody,
            CancelServiceEventData,
            CancelServiceEventParameters,
            OperationError<CancelServiceEventError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Cancel
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventsService.cancelServiceEvent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventsService.cancelServiceEvent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelServiceEventSchema,
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
      ):
        | Mutation<
            CancelServiceEventData,
            CancelServiceEventError,
            MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelServiceEventSchema,
              CancelServiceEventBody,
              CancelServiceEventData,
              CancelServiceEventParameters,
              OperationError<CancelServiceEventError>,
              TContext
            >
      ): Array<
        Mutation<
          CancelServiceEventData,
          CancelServiceEventError,
          MutationVariables<CancelServiceEventBody, CancelServiceEventParameters>,
          TContext
        >
      >;
    };
    schema: CancelServiceEventSchema;
    types: {
      parameters: CancelServiceEventParameters;
      data: CancelServiceEventData;
      error: CancelServiceEventError;
      body: CancelServiceEventBody;
    };
  };
}
/** @summary Create */
export const createServiceEvent = {
  schema: {
    method: 'post',
    url: '/service_events/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['createServiceEvent'];
};
/** @summary Reschedule */
export const rescheduleServiceEvent = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/reschedule',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: RescheduleServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['rescheduleServiceEvent'];
};
/** @summary Cancel */
export const cancelServiceEvent = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/cancel',
    security: ['HTTPBearer'],
  },
} as {
  schema: CancelServiceEventSchema;
  [QraftServiceOperationsToken]: ServiceEventsService['cancelServiceEvent'];
};
export const serviceEventsService = {
  createServiceEvent,
  rescheduleServiceEvent,
  cancelServiceEvent,
} as const;
type CreateServiceEventSchema = {
  method: 'post';
  url: '/service_events/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateServiceEventParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateServiceEventData = paths['/service_events/']['post']['responses']['200']['content']['application/json'];
type CreateServiceEventError = paths['/service_events/']['post']['responses']['422']['content']['application/json'];
type CreateServiceEventBody = paths['/service_events/']['post']['requestBody']['content']['application/json'];
type RescheduleServiceEventSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/reschedule';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type RescheduleServiceEventParameters = paths['/service_events/{service_event_id}/reschedule']['post']['parameters'];
type RescheduleServiceEventData =
  paths['/service_events/{service_event_id}/reschedule']['post']['responses']['200']['content']['application/json'];
type RescheduleServiceEventError =
  paths['/service_events/{service_event_id}/reschedule']['post']['responses']['422']['content']['application/json'];
type RescheduleServiceEventBody =
  paths['/service_events/{service_event_id}/reschedule']['post']['requestBody']['content']['application/json'];
type CancelServiceEventSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/cancel';
  security: ['HTTPBearer'];
};
type CancelServiceEventParameters = paths['/service_events/{service_event_id}/cancel']['post']['parameters'];
type CancelServiceEventData =
  paths['/service_events/{service_event_id}/cancel']['post']['responses']['200']['content']['application/json'];
type CancelServiceEventError =
  paths['/service_events/{service_event_id}/cancel']['post']['responses']['422']['content']['application/json'];
type CancelServiceEventBody = undefined;
